import { render, staticRenderFns } from "./AddorderlinePage.vue?vue&type=template&id=56f369e0"
import script from "./AddorderlinePage.vue?vue&type=script&lang=js"
export * from "./AddorderlinePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports